import { axiosLocal5000Local } from "../axios";

export async function getSymbolsDetails(selectedSymbol:any,startDate:any, endDate:any, calculation_type:any ){
    return await axiosLocal5000Local.post(`options/find-by-symbols-and-dates`,{
        s_symbol: selectedSymbol,
        startDate : startDate,
        endDate : endDate,
        type: calculation_type
    }).then((res:any)=>{
        return res?.data
    }).catch((error:any)=>{
        console.log("Exception occured while fetching the symbol details for historical performance : ", error)
        return {"error": true}       
    })
}

export async function getAllDetails(){
    return await axiosLocal5000Local.get(`options/`).then((res:any)=>{
        return res;
    }).catch((error:any)=>{
        console.log("Exception occured while fetching all the details for performance page(options) : ", error)
        return {"error": true}
    })
}

export async function getRollingChartsDetailsSymbolWise(drpValue:any, startDate:any, endDate:any) {
    return await axiosLocal5000Local.post(`options/get-symbol-chart`, {
        s_symbol: drpValue,
        startDate: startDate,
         endDate: endDate 
    }).then((res:any)=>{
        return res
    }).catch((error:any)=>{
        console.log("Exception occured while fetching all the charts data for performance page(options) : ", error)
        return {"error": true}
    })
}

export async function getPropertyCharts(selectedColumn:any, startDate:any, endDate:any, drpValue:any) {
    return await axiosLocal5000Local.post(`options/fetch-column-data`, {
        column_name: selectedColumn,
        startDate: startDate,
        endDate: endDate, 
        s_symbol: drpValue 
    }).then((res:any)=>{
        return res?.data ;
    }).catch((error:any)=>{
        console.log("Exception occured while fetching the details or property charts for performance page(options) : ", error)
        return {"error": true}
    })
}

export async function getAllSymbolSummaryChart(selectedColumn:any, startDate:any, endDate:any) {
    return await axiosLocal5000Local.post(`options/fetch-all-periods-charts`, {
        column_name: selectedColumn,
        startDate: startDate,
        endDate: endDate, 
    }).then((res:any)=>{
        return res?.data ;
    }).catch((error:any)=>{
        console.log("Exception occured while Avg fetiching charts for all symbols for performance page(options) : ", error)
        return {"error": true}
    })

}

export async function getTableExport(selectedSymbol:any,startDate:any, endDate:any, calculation_type:any ){
    return await axiosLocal5000Local.post(`options/get-table-for-export`,{
        s_symbol: selectedSymbol,
        startDate : startDate,
        endDate : endDate,
        type: calculation_type
    }).then((res:any)=>{
        return res?.data
    }).catch((error:any)=>{
        console.log("Exception occured while fetching ExportPdf data for historical performance : ", error)
        return {"error": true}
        
    })
}
